import { useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { Button } from '@gisatcz/ptr-atoms';
import { Menu, MenuItem } from '@gisatcz/ptr-atoms';
import { withNamespaces } from '@gisatcz/ptr-locales';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var User = function User(_ref) {
  var user = _ref.user,
      inverted = _ref.inverted,
      logout = _ref.logout,
      onMount = _ref.onMount,
      t = _ref.t,
      login = _ref.login;
  useEffect(function () {
    if (typeof onMount === 'function') {
      onMount();
    }
  }, []);

  if (user) {
    var name = user.data.name || user.data.email;
    return /*#__PURE__*/_jsxs("div", {
      className: "ptr-user",
      children: [/*#__PURE__*/_jsx("div", {
        className: "ptr-user-image"
      }), /*#__PURE__*/_jsx("div", {
        className: "ptr-user-name",
        children: name
      }), /*#__PURE__*/_jsx("div", {
        className: "ptr-user-options",
        children: /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {},
          icon: "dots",
          invisible: true,
          inverted: inverted,
          children: /*#__PURE__*/_jsx(Menu, {
            bottom: true,
            left: true,
            children: /*#__PURE__*/_jsx(MenuItem, {
              onClick: logout,
              children: t('user.logout')
            })
          })
        })
      })]
    });
  } else {
    // It means render another component.
    return /*#__PURE__*/_jsx("div", {
      className: "ptr-user",
      children: /*#__PURE__*/_jsx("div", {
        className: "ptr-user-login",
        children: /*#__PURE__*/_jsx(Button, {
          invisible: true,
          inverted: inverted,
          onClick: login,
          children: t('user.login')
        })
      })
    });
  }
};

User.propTypes = {
  user: PropTypes.object,
  inverted: PropTypes.bool,
  onMount: PropTypes.func,
  logout: PropTypes.func,
  login: PropTypes.func,
  t: PropTypes.func
};
export default withNamespaces()(User);